import { ThirdPartyDraggable } from '@fullcalendar/interaction';
import React, { useEffect, useRef } from 'react';
import { getDraggableEventData } from 'shared/lib/full-calendar';
import { DataType } from 'shared/types/data-type';
import { Task } from 'shared/types/task';
import { WeekDays } from 'shared/types/week-days';

export type Options = {
  listRef: React.RefObject<HTMLDivElement> | undefined;
  tasks: Task[];
  weekStartsOn: WeekDays;
  includeDuration?: boolean;
  includeDueDateAsOriginDate?: boolean;
};

export const useRegisterFullCalendarDraggableItems = ({
  listRef,
  tasks,
  weekStartsOn,
  includeDuration,
  includeDueDateAsOriginDate,
}: Options) => {
  // read tasks through a ref so a changed list doesn't destroy + re-register the draggable
  const tasksRef = useRef(tasks);
  tasksRef.current = tasks;

  useEffect(() => {
    if (!listRef?.current) {
      return;
    }

    const thirdPartyDraggable = new ThirdPartyDraggable(listRef.current, {
      // eslint-disable-next-line max-len -- long selector
      itemSelector: `
       [role="treeitem"]:has([data-component-type="${DataType.Task}"]),
       [role="treeitem"]:has([data-component-type="${DataType.Goal}"]),
       [role="treeitem"]:has([data-component-type="${DataType.LifeArea}"])
     `,
      eventData: (el) =>
        getDraggableEventData(el, {
          tasks: tasksRef.current,
          weekStartsOn,
          includeDuration,
          includeDueDateAsOriginDate,
        }),
    });

    return () => thirdPartyDraggable?.destroy();
  }, [includeDuration, includeDueDateAsOriginDate, listRef, weekStartsOn]);
};
